export default __webpack_public_path__ + "static/media/icon_privacy_home_info.b379e3f9.svg";